module.exports = __webpack_public_path__ + "static/img/100.5817ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/100.png
// module id = tj0W
// module chunks = 0